import { useQuery } from "@tanstack/react-query";
import { getPublicFlowImageUrl } from "@/lib/api/public-flow/image";
import { useSessionToken } from "@/lib/context/public-session-context";

export const publicImageKeys = {
  component: (componentId: string) => ["publicFlow", "image", componentId] as const,
};

/**
 * The server presigns uploaded images for an hour. Refetching every 30 minutes,
 * not just marking the URL stale, keeps a mounted `<img>` from being left on an
 * expired URL during a long session.
 */
const THIRTY_MINUTES = 30 * 60 * 1000;

export function usePublicFlowImageUrl(componentId: string) {
  const token = useSessionToken();
  const { data, isLoading } = useQuery({
    queryKey: publicImageKeys.component(componentId),
    queryFn: () => getPublicFlowImageUrl(componentId, token),
    enabled: !!token,
    staleTime: THIRTY_MINUTES,
    refetchInterval: THIRTY_MINUTES,
  });
  return { url: data?.url ?? null, alt: data?.alt ?? "", isLoading };
}
